import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { MenuService } from './menu.service';
import { SUCCESS_RESPONE } from '../../../@core/customs/constants';
import { AuthService } from '../../../@core/auth.service';
import { ListMenuModel } from '../../../@core/data/app-qtht.service';

@Component({
  selector: 'ngx-menu',
  styleUrls: ['menu.component.scss'],
  templateUrl: './menu.component.html',
})
export class MenuComponent implements OnInit {
  menu: NbMenuItem[] = [];


  constructor(private menuService: MenuService,
    private authService: AuthService,
    private router: Router) {
  }

  ngOnInit(): void {
    let checkLoadMenu = false;
    this.menuService.getNbMenuItem().subscribe(result => {
      if (result.length !== 0 || checkLoadMenu) {
        this.menu = result;
      } else {
        this.menuService.getMenuByUserLogin().subscribe(menu => {
          if (menu.code === SUCCESS_RESPONE) {
            this.loadMenu(menu.data);
            this.menuService.setRoutingSaveCheckRole(menu.data);
            checkLoadMenu = true;
          }
        },
        (() => {
          this.authService.logout();
          this.router.navigate(['/login']);
        }));
      }
    });
  }

  loadMenu(lst: ListMenuModel[]) {
    lst.filter(c => (c.parent === null || c.parent === '')).forEach(element => {
      const itemMenu = new NbMenuItem();
      itemMenu.title = element.text;
      itemMenu.link = element.state;
      if (lst.findIndex(c => c.parent === element.value) !== -1) {
        itemMenu.children = this.loadMenuChildrent(element, lst);
      }
      this.menu.push(itemMenu);
    });
    this.menuService.setNbMenuItem(this.menu);
  }

  loadMenuChildrent(item: ListMenuModel, lst: ListMenuModel[]) {
    const result = [];
    lst.filter(c => c.parent === item.value).forEach(element => {
      const itemChilrent = new NbMenuItem;
      itemChilrent.title = element.text;
      itemChilrent.link = element.state;
      if (lst.findIndex(t => t.parent === element.value) !== -1) {
        itemChilrent.children = this.loadMenuChildrent(element, lst);
      }
      result.push(itemChilrent);
    });
    return result;
  }

  // menu = MENU_ITEMS;

  // NbMenuItem[] = [
  //   {
  //     title: 'Dashboard',
  //     icon: 'home-outline',
  //     link: '/pages/dashboard',
  //     home: true,
  //   },
  //   {
  //     title: 'FEATURES',
  //     group: true,
  //   },
  //   {
  //     title: 'Auth',
  //     icon: 'lock-outline',
  //     children: [
  //       {
  //         title: 'Login',
  //         link: '/auth/login',
  //       },
  //       {
  //         title: 'Register',
  //         link: '/auth/register',
  //       },
  //       {
  //         title: 'Request Password',
  //         link: '/auth/request-password',
  //       },
  //       {
  //         title: 'Reset Password',
  //         link: '/auth/reset-password',
  //       },
  //     ],
  //   },

}
